import { Fragment } from 'react';
import { Link, Outlet } from 'react-router';
import { SidebarProvider, SidebarInset, SidebarTrigger } from '@/components/ui/sidebar';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Separator } from '@/components/ui/separator';
import { AppSidebar } from './AppSidebar';
import { ThemeToggle } from './ThemeToggle';
import { useAuth } from '@/lib/use-auth';
import { usePageTitle } from '@/lib/use-page-title';
import { TutorProfileProvider } from '@/lib/tutor-profile-context';

export function DashboardLayout() {
  const { user } = useAuth();
  const { label, parent } = usePageTitle(user?.role);

  const shell = (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 border-b border-border-subtle bg-background">
          <div className="flex flex-1 items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1 text-foreground" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4"
            />
            <Breadcrumb>
              <BreadcrumbList>
                {parent ? (
                  <Fragment>
                    <BreadcrumbItem>
                      <BreadcrumbLink asChild>
                        <Link to={parent.href}>{parent.label}</Link>
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbPage>{label}</BreadcrumbPage>
                    </BreadcrumbItem>
                  </Fragment>
                ) : (
                  <BreadcrumbItem>
                    <BreadcrumbPage>{label}</BreadcrumbPage>
                  </BreadcrumbItem>
                )}
              </BreadcrumbList>
            </Breadcrumb>
            <div className="ml-auto">
              <ThemeToggle />
            </div>
          </div>
        </header>
        <div className="flex flex-1 flex-col p-6 pt-4">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );

  // Tutor profile context is shared between AppSidebar (onboarding nav) and OnboardingPage
  return user?.role === 'tutor' ? (
    <TutorProfileProvider>{shell}</TutorProfileProvider>
  ) : shell;
}
